import { Collapse, Divider } from "antd";
import {
	ActionButtonComponent,
	EditEmployeeTransactionsContainer,
	EditItemsContainer,
} from "./style";
import { CDNFileItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useCDNFileContext } from "../../context/CDNFileContext/CDNFileContext";

const AddCDNFile = () => {
	const { addCDNFile, loadingAddCDNFileData } = useCDNFileContext();
	return (
		<EditEmployeeTransactionsContainer>
			<EditItemsContainer>
				<h3>Yeni CDN Dosyası Ekleme</h3>
				<Divider />
				<Collapse
					items={CDNFileItems}
					expandIconPosition="end"
					bordered={false}
					expandIcon={({ isActive }) => (
						<UpOutlined rotate={isActive ? 0 : -180} />
					)}
					defaultActiveKey={["1", "2", "3"]}
				/>
				<ActionButtonComponent>
					<MainButtonComponent onClick={addCDNFile} loading={loadingAddCDNFileData}>
						Dosyayı Ekle
					</MainButtonComponent>
				</ActionButtonComponent>
			</EditItemsContainer>
		</EditEmployeeTransactionsContainer>
	);
};

export default AddCDNFile;
